import React from 'react';
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import ButtonComponent from 'src/components/ButtonComponent';
import { GetImportsResponse } from 'src/redux/services/imports';
import Chip from 'src/frontend-common/components/Chip';
import SearchIcon from '@mui/icons-material/Search';
import { Import } from 'src/dto/Import';

const InsightsTable: React.FC<{ dataTable?: GetImportsResponse }> = ({ dataTable }) => {
  const [page, setPage] = React.useState(0);

  const navigate = useNavigate();

  const tableCells = ['File Name', 'Status', 'Records', 'Errors', 'User', 'Date', ' '];
  const rowsPerPage = 10;

  const handleChangePage = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {tableCells.map((tableCell) => (
                <TableCell align="left" key={tableCell}>
                  {tableCell}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={{ backgroundColor: 'white' }}>
            {dataTable?.documents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item: Import, i: number) => {
              const progressValue = (item.number_of_processed_rows || 0) / ((item.number_of_retry || 0) + (item.number_of_rows || 1));
              return (
                <TableRowWrapper key={`${item.key}-${item.created_at}-${item.import_status}`}>
                  <TableCell align="left">{item.original_file_name}</TableCell>
                  <TableCell align="left">
                    <Chip variant="progress" progressPerc={progressValue * 100} />
                  </TableCell>

                  <TableCell align="left">{item.number_of_rows}</TableCell>
                  <TableCell align="left">{item.number_of_errors}</TableCell>
                  <TableCell align="left">{item.author}</TableCell>
                  <TableCell align="left">{item?.created_at ? format(new Date(item.created_at), 'yyyy/MM/dd | hh:mm') : ''}</TableCell>

                  <TableCell key={`action-${i}`}>
                    <ButtonComponent
                      icon={<SearchIcon />}
                      buttontype="icon"
                      disabled={
                        item.import_status !== 'COMPLETED' ||
                        (item.import_status === 'COMPLETED' && (item.validation_errors > 0 || item.number_of_errors > 0 || item.processing_errors > 0))
                      }
                      onClick={() => {
                        navigate(`/feature-details/${item.key}`);
                      }}
                    />
                  </TableCell>
                </TableRowWrapper>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        style={{ backgroundColor: 'white' }}
        count={dataTable?.documents.length || 0}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[rowsPerPage]}
      />
    </>
  );
};

export default InsightsTable;

const TableRowWrapper = styled(TableRow)(() => ({
  '&:hover': {
    backgroundColor: '#F3F4F6',
  },
}));
